import { Routes } from "@angular/router";
import { tokenGuard } from "./core/guard/eidos-token/eidos-token.guard";
import { ErrorModule } from "@eidos/error/error.module";



export const mainRoutes:Routes = [
  {
    path:'',
    pathMatch: "full",
    redirectTo:'entity-master'
  },
  {
    path: 'error',
    loadChildren:() => import(/* webpackChunkName: "Error" */ '@eidos/error/error.module')
      .then(m => m.ErrorModule),
    pathMatch: 'prefix'
  },
  {
    path:'login',
    loadComponent:() => import('@eidos/pages/eidos-login/eidos-login.component')
      .then(c => c.EidosLoginComponent)
      .catch(() => ErrorModule)
  },
  {
    path: 'token/:token',
    loadComponent:() => import('@eidos/pages/eidos-login-token/eidos-login-token.component')
      .then(c => c.EidosLoginTokenComponent)
      .catch(() => ErrorModule),
    pathMatch: 'prefix'
  },
  {
    path: 'reset/:resetId',
    loadComponent:() => import('@eidos/pages/eidos-reset-credentials/eidos-reset-credentials.component')
      .then(c => c.EidosResetCredentialsComponent)
      .catch(() => ErrorModule),
    pathMatch: 'prefix'
  },
  {
    path:'entity-master',
    canActivate: [tokenGuard],
    title:'AK Mobile',
    loadChildren:() => import('@entity_master/entity-master.module')
      .then(m => m.EntityMasterModule)
      .catch(() => ErrorModule)
  },
  {
    path:'**',
    pathMatch:'full',
    redirectTo:'error'
  }
];
